import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'step' ];

  initialize() {
    this.showStep();
  }

  reformatId(id) {
    if (id < 0) return 0;
    if (id >= this.stepTargets.length) return this.stepTargets.length - 1;
    return id;
  }

  next(event) {
    event.preventDefault();
    this.index += 1;
  }

  previous(event) {
    event.preventDefault();
    this.index -= 1;
  }

  get index() {
    return Number(this.data.get("index") || 0);
  }

  set index(value) {
    this.data.set("index", this.reformatId(value));
    this.showStep();
  }

  showStep() {
    this.stepTargets.forEach((element, elementIndex) => {
      element.classList.toggle("current-step", this.index == elementIndex)
    })
  }
}
